import { FormDate } from 'components/form/FormDate';
import { FormField } from 'components/form/FormField';
import { FormGroup } from 'components/form/FormGroup';
import { FormInput } from 'components/form/FormInput';
import { FormTextArea } from 'components/form/FormTextArea';
import { FormToggle } from 'components/form/FormToggle';
import { React, useState } from 'libs/react';
/**
 * @component StoreGiftFields
 * @since 1.0.0
 */
export function StoreGiftFields() {
    const [isGift, setIsGift] = useState(false);
    const [sendEmail, setSendEmail] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(FormGroup, null,
            React.createElement(FormField, null,
                React.createElement(FormToggle, { value: "0", name: "isGift", label: t('Want to offer as a gift?'), options: [
                        { label: t('No'), value: '0' },
                        { label: t('Yes'), value: '1' }
                    ], onChange: (value) => {
                        const next = value === '1';
                        setIsGift(next);
                        if (!next) {
                            setSendEmail(false);
                        }
                    } }))),
        isGift && (React.createElement(React.Fragment, null,
            React.createElement(FormGroup, null,
                React.createElement(FormField, null,
                    React.createElement(FormInput, { type: "text", name: "giftToName", label: t('Recipient name'), placeholder: t('Enter recipient name…'), required: true, pattern: '^(?!\\s*$).+' })),
                React.createElement(FormField, null,
                    React.createElement(FormTextArea, { name: "giftMessage", label: t('Gift message'), placeholder: t('Write a message for the recipient…'), rows: 3 }))),
            React.createElement(FormGroup, null,
                React.createElement(FormField, null,
                    React.createElement(FormToggle, { value: "0", name: "giftSendEmail", label: t('Send the gift by email'), options: [
                            { label: t("I'll give it myself"), value: '0' },
                            { label: t('Send to the recipient'), value: '1' }
                        ], onChange: (value) => {
                            setSendEmail(value === '1');
                        } }))),
            sendEmail && (React.createElement(FormGroup, null,
                React.createElement(FormField, null,
                    React.createElement(FormInput, { type: "email", name: "giftToEmail", label: t('Recipient email'), placeholder: t('Enter recipient email…'), required: true, pattern: '^(?!\\s*$).+' })),
                React.createElement(FormField, null,
                    React.createElement(FormDate, { name: "giftSendAt", label: t('Send on'), time: false, required: true, minDate: new Date(), defaultValue: new Date().toISOString() }))))))));
}
